export function lowerCaseFirstChar(str: string): string {
  return str && str.charAt(0).toLowerCase() + str.slice(1)
}
